import { Benefit } from '@spo/storybook';
import { clsx } from 'clsx';
import './productBenefits.scss';
import { SpoNeedAndSegmentationResponseBenefitsItem } from '@spo/types';

export interface ProductBenefitsProps {
  benefits: SpoNeedAndSegmentationResponseBenefitsItem[];
  inline?: boolean;
}

export const ProductBenefits = ({
  benefits,
  inline = false,
}: ProductBenefitsProps) => {
  return (
    <div
      data-testid="product-benefits-container"
      className={clsx('product-benefits-container', { inline })}
    >
      <div className="product-benefits">
        {benefits.map((benefit) => (
          <Benefit key={benefit.id} benefit={benefit} />
        ))}
      </div>
    </div>
  );
};
